import { render, staticRenderFns } from "./NewsIndexAdmin.vue?vue&type=template&id=a30337ae"
import script from "./NewsIndexAdmin.vue?vue&type=script&lang=js"
export * from "./NewsIndexAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports